import { convertCentsToDollars } from '@/utils/helpers';
import { i18n } from '@/plugins/i18n';
import type { Directive } from 'vue';

const formatCentsToDollars: Directive<HTMLElement, number> = {
	beforeMount(el, binding) {
		el.innerHTML = i18n.global.n(convertCentsToDollars(binding.value), 'currency');
	},
	beforeUpdate(el: HTMLElement, binding: { value: number }) {
		el.innerHTML = i18n.global.n(convertCentsToDollars(binding.value), 'currency');
	},
};

export default formatCentsToDollars;
